import { render } from "./WalletGraph.vue?vue&type=template&id=6660ee45&scoped=true"
import script from "./WalletGraph.vue?vue&type=script&lang=js"
export * from "./WalletGraph.vue?vue&type=script&lang=js"

import "./WalletGraph.vue?vue&type=style&index=0&id=6660ee45&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6660ee45"]])

export default __exports__